import UIComponent from "../ui/component";
import FilesApi from "../api/files";
import { AbstractApi } from "../api";
import goals from "../utils/goals";

class IntroOfferApi extends AbstractApi {
    async review(url) {
        return await this.post("/intro-offer/review", { url });
    }
}

const api = new IntroOfferApi();

/**
 * A2T-48: спецблок для новых на плашке доплаты — отзыв, регистрация, «150 минут за 150 ₽» на 3 дня.
 * Цена и право на оффер проверяются на сервере (IntroOfferService), здесь только UI и цели Метрики.
 */
export class IntroOffer extends UIComponent {
    init() {
        this.includeComponents({
            errorBag: "document@.js-upload-form-error",
        });
        if (!Number(this.available_region)) {
            this.includeComponents({
                regionPaymentModal: "document@#regionPaymentModal",
            });
        }

        goals.reach("intro_block_shown");

        this.offerBtn?.on("click", this.onOfferClick.bind(this));
        this.reviewForm?.on("submit", this.onReviewSubmit.bind(this));
        this.registerLink?.on("click", () => goals.reach("intro_register_click"));
        this.otherOffersLink?.on("click", (e) => {
            e.preventDefault();
            goals.reach("intro_other_offers_click");
            this.showStandardOffers();
            this.otherOffersLink.hide();
        });
        this.reviewInput?.on("focus", () => {
            if (!this.reviewFocused) {
                this.reviewFocused = true;
                goals.reach("intro_review_click");
            }
        });

        this.startTimer();
    }

    startTimer() {
        if (!this.expires_at || !this.timer) {
            return;
        }

        const end = new Date(this.expires_at).getTime();
        const tick = () => {
            const left = end - Date.now();
            if (left <= 0) {
                // Время вышло — спецблок скрываем целиком и возвращаем обычные тарифы
                clearInterval(this.timerId);
                this.hide();
                this.showStandardOffers();
                return;
            }
            const h = Math.floor(left / 3600000);
            const m = Math.floor((left % 3600000) / 60000);
            const s = Math.floor((left % 60000) / 1000);
            this.timer.element.textContent = `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
        };

        tick();
        this.timerId = setInterval(tick, 1000);
    }

    showStandardOffers() {
        document.getElementById("surchargeStandardOffers")?.classList.remove("d-none");
    }

    async onOfferClick(e) {
        e.preventDefault();
        goals.reach("intro_offer_click");

        const fileId = window.location.pathname.split("/").pop();
        const paymentData = {
            files: [fileId],
            addToQueue: 1,
            options: { language: this.language },
            offer: "intro_offer",
            return: window.location.href,
        };

        if (!Number(this.available_region)) {
            this.regionPaymentModal?.show(paymentData, true);
            return;
        }

        this.offerBtn.disable();
        // При успехе API сам редиректит на оплату (response.redirect)
        FilesApi.transcribe(paymentData).catch((error) => {
            this.offerBtn.enable();
            this.errorBag?.show(error?.message || error);
        });
    }

    async onReviewSubmit(e) {
        e.preventDefault();
        const url = this.reviewInput?.element.value.trim();
        if (!url) {
            return;
        }

        this.reviewBtn?.disable();
        try {
            const result = await api.review(url);
            if (result?.status === "sent") {
                goals.reach("intro_review_sent");
                this.reviewForm.hide();
            } else {
                this.reviewBtn?.enable();
            }
            this.showReviewMessage(result?.message || result?.errors?.url?.[0], result?.status === "sent");
        } catch (error) {
            this.reviewBtn?.enable();
            this.showReviewMessage(error?.url?.[0] || error?.message || String(error), false);
        }
    }

    showReviewMessage(text, ok) {
        if (!this.reviewMessage || !text) {
            return;
        }
        this.reviewMessage.element.textContent = text;
        this.reviewMessage.element.classList.toggle("text-success", ok);
        this.reviewMessage.element.classList.toggle("text-danger", !ok);
        this.reviewMessage.show();
    }
}
